<a [href]="getHref()"
	target="_blank"
  class="nav-link"
	style="font-size:12px;">
	<i class="fa fa-fw fa-external-link"></i>
	Make this a public UC Delivers Impact Story
</a>
